import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";

/* General */
import "./App.css";
import HomePage from "./pages/General/HomePage.js";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout.js";
import { PrivateRoutes } from "./routes/privateRoute.js";
import { PublicRoutes } from "./routes/publicRoute.js";

/*  Public routes  */

import TokenExpiryCheckWrapper from "./utils/TokenExpiryCheckWrapper"; // Import the new wrapper

function App() {
  const { darkMode } = useSelector((state) => state.ui);
  const { isAuthenticated } = useSelector((state) => state.auth); // Get auth state

  return (
    <div className={darkMode ? "dark" : ""}>
      <Router>
        {/* Include the TokenExpiryCheckWrapper here to ensure it has access to Router context */}
        <TokenExpiryCheckWrapper />
        <Routes>
          {/* Public routes */}
          <Route path="/homepage" element={<HomePage />} />
          {PublicRoutes.map(({ path, element }, index) => (
            <Route key={index} path={path} element={element} />
          ))}

          {/* Protected route with layout */}
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <DashboardLayout />
              ) : (
                <Navigate to="/homepage" replace />
              )
            }
          >
            {/* Redirect root path to a default dashboard or landing page */}
            <Route index element={<Navigate to="/homepage" />} />

            {/* Private app routes */}
            <Route
              index
              element={
                <Navigate
                  to={isAuthenticated ? "/dashboard" : "/homepage"}
                  replace
                />
              }
            />
            {PrivateRoutes.map(({ path, element }, index) => (
              <Route key={index} path={path} element={element} />
            ))}
          </Route>
          {/* Fallback for all unmatched routes */}
          <Route
            path="*"
            element={
              <Navigate
                to={isAuthenticated ? "/dashboard" : "/homepage"}
                replace
              />
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
